import { FaHistory } from "react-icons/fa";
import Pagination from "react-js-pagination";
import FilterDropdown from "../modals/FilterDropdown";
import {filters, TYPES} from "../utils/filter";
import useSearchApi from "../hooks/useSearchApi";
import {FlexCenter, FlexStart, PaginationContainer} from "../styles/CommonStyles";
import { HeaderColumn, HeaderRow, NoDataWrapper, FilterWrapper } from "../styles/OrdersStyle";
import Text from "../utils/Text";
import { useMainContext } from "../contexts/main";
import {useWindowSize} from "../hooks/common/useWindowSize";
import { TABLET_SIZE} from "../constants/common";
import {useMarketQuery} from "../services/react-query/useMarketQuery";
import {useEffect, useState} from "react";
import {ScaleLoader} from "react-spinners";


const FilterLayout = ({
      children,
      state,
      headers,
      data,
      loading,
      totalPages,
      hasDateOptions = true,
      hasCoinOption,
      hasTradeOptions,
      hasTypeOptions,
} = {}) => {

    const { main: { theme } } = useMainContext()
    const { width } = useWindowSize()
    const { data: market } = useMarketQuery()

    const [coins, setCoins] = useState([])
    useEffect(() => {
        if (market) {
            setCoins(market)
        }
    }, [market])

    const { filterQueries } = state
    const {
        onPageChange,
        onOptionChanged
    } = useSearchApi(state)


    return (
        <>
            <FilterWrapper style={{margin: width > TABLET_SIZE && "0 20px" }}>
                <FlexStart>
                    {hasCoinOption &&
                        <FilterDropdown
                            options={market}
                            width='300px'
                            defaultOption='coinFilter'
                            onOptionChanged={(idx) => onOptionChanged(idx, TYPES.COIN)}
                            isCoin
                            type='buy'
                        />
                    }
                    {hasDateOptions &&
                        <FilterDropdown
                            options={filters.date}
                            icon={<FaHistory size={14} color={theme === 'dark' ? '#c3c5b7' : '#191c20'} />}
                            defaultOption='pickDate'
                            onOptionChanged={(idx) => onOptionChanged(idx, TYPES.DATE)}
                        />
                    }
                    {hasTypeOptions &&
                        <FilterDropdown
                            options={filters.type}
                            defaultOption='transactionType'
                            onOptionChanged={(idx) => onOptionChanged(idx, TYPES.TYPE)}
                        />
                    }
                    {hasTradeOptions && (
                        <FilterDropdown
                            options={filters.submit}
                            defaultOption='tradeType'
                            onOptionChanged={(idx) => onOptionChanged(idx, TYPES.SUBMIT)}
                        />
                    )}
                </FlexStart>
            </FilterWrapper>
            <HeaderRow>
                {headers.map(header => (
                    <HeaderColumn key={header.title} width={header.width}>
                        <Text tid={header.title} />
                    </HeaderColumn>
                ))}
            </HeaderRow>
            {!loading && children}
            {loading &&
                <FlexCenter width="100%" height="200px">
                    <ScaleLoader
                        height={22}
                        width={2}
                        color='#0d60a1'
                    />
                </FlexCenter>
            }
            {(data?.data?.length && totalPages) ?
                <PaginationContainer bottom="0">
                    <Pagination
                        activePage={filterQueries.page}
                        itemsCountPerPage={10}
                        totalItemsCount={totalPages}
                        pageRangeDisplayed={3}
                        onChange={(p) => onPageChange(p)}
                        itemClass={theme === "light" ? "d-page-item" : "page-item"}
                        linkClass={theme === "light" ? "d-page-link" : "page-link"}
                    />
                </PaginationContainer>
                : null
            }
            {(data?.data?.length === 0 && !loading) &&
                <NoDataWrapper top="200px">
                    <img alt=" " src={require("../assets/images/noData.png")} width="100px" />
                </NoDataWrapper>
            }
        </>
    )
}


export default FilterLayout;
